<h3>{{'_General_Data_Import_Export_Text_' | translate }}</h3>

<div >
    <ul ngbNav #nav="ngbNav" class="nav-pills cc-tab">
      <li [ngbNavItem]="1">
        <a ngbNavLink>{{'_General_Data_Import_Text_' | translate }} </a>
        <ng-template ngbNavContent>
            <div class="cc-content-wrapper">
              <app-data-import></app-data-import>
            </div>
           
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink>{{'_General_Data_Export_Text_' | translate }} </a>
        <ng-template ngbNavContent> 
            <div class="cc-content-wrapper">
                <app-data-export></app-data-export>
            </div>
        </ng-template>
      </li>
    </ul>
  
    <div [ngbNavOutlet]="nav" class=""></div>
  </div>
